// extracted by mini-css-extract-plugin
module.exports = {"custom-gradient-fid":"loyalty_custom-gradient-fid__1tAk0","customGradientFid":"loyalty_custom-gradient-fid__1tAk0"};